import dayjs from "dayjs";
import { eventStatus } from "./date";

export const visitorBodyParameters = ({
                                          isRegistration,
                                          exhibitionId,
                                          exhibitorId,
                                          visitorId,
                                          isUpdate,
                                          sendMessages
                                      }, values) => {

    let characterization = ""
    if(values.characterization) {
        if(typeof values.characterization === 'string') {
            characterization = values.characterization
        } else if(values.characterization.id) {
            characterization = values.characterization.id
        }
    }

    return ({
        ExhibitionId: exhibitionId,
        ...(values.visitorId ? {id: values.visitorId} : {}),
        ...(values.visitorApproved ? {VisitorApproved: values.visitorApproved} : {}),
        ...(values.id && isUpdate ? {ContactId: values.id} : {}),
        ...(values.characterization ? {CharacterizationId: characterization} : {}),
        ...(values.city ? {City: values.city} : {}),
        ...(values.companyAddress ? {CompanyAddress: values.companyAddress} : {}),
        ...(values.companyName ? {CompanyName: values.companyName} : {}),
        ...(values.companyWebsite ? {CompanyWebSite: values.companyWebsite} : {}),
        ...(values.instagram ? {Instagram: values.instagram} : {}),
        ...(values.facebook ? {Facebook: values.facebook} : {}),
        ...(values.countries ? {CountryId: values.countries && values.countries.id ? values.countries.id : ''} : {}),
        ...(values.email ? {email: values.email} : {}),
        ...(values.hasRevisited ? {hasRevisited: values.hasRevisited} : {}),
        ...(values.interests ? {Interests: values.interests.length > 0 ? values.interests.map(v => v.id).toString() : ""} : {}),
        ...(values.isIndividual ? {isIndividual: values.isIndividual} : {}),
        ...(exhibitorId ? {ExhibitorId: exhibitorId} : {}),
        ...(values.organizerApprovalStatus ? {organizerApprovalStatus: values.organizerApprovalStatus} : {}),
        ...(values.organizerApprovalRejectReason ? {organizerApprovalRejectReason: values.organizerApprovalRejectReason} : {}),
        ...(values.vatNumber ? {VatNumber: values.vatNumber} : {}),
        ...(values.name ? {Name: values.name} : {}),
        ...(values.phone ? {Phone: values.phone} : {}),
        ...(values.companyFirm ? {CompanyFirm: values.companyFirm} : {}),
        ...(values.mobilePhone ? {MobilePhone: values.mobilePhone} : {}),
        ...(values.postalCode ? {PostalCode: values.postalCode} : {}),
        ...(values.personCount ? {PersonCount: values.personCount} : {}),
        ...(values.otherInterests ? {OtherInterests: values.otherInterests} : {}),
        ...(values.position ? {Position: values.position} : {}),
    })
}

export const findCountryCode = (currentPhoneCode, mobilePhone, phoneCodes) => {
    let countryPhoneCode = null
    if (!String(mobilePhone).startsWith(String(currentPhoneCode))) {
        let found = false;
        let foundAt = 0;
        for (let i = 0; i < phoneCodes.length; i++) {
            if (phoneCodes[i].phoneCode !== '' && mobilePhone.startsWith(phoneCodes[i].phoneCode)) {
                if (!found) {
                    foundAt = i;
                    found = true;
                } else {
                    found = false;
                    break;
                }
            }
        }
        if (found) {
            countryPhoneCode = phoneCodes[foundAt]
        }
    }
    return countryPhoneCode
}

export const showOption = (language) => (option) => {
    if (typeof option === 'string') {
        return option
    }
    if (typeof option.description === 'string') {
        return option.description
    }
    if (!option.description) {
        return option[language]
    }
    return option.description[language]
}

export const searchFieldMappings = {
    name: "Name",
    email: "email",
    phone: "Phone",
    mobilePhone: "MobilePhone",
    vatNumber: "vatNumber",
    companyName: "CompanyName",
    companyFirm: "CompanyFirm"
}

export const exhibitionIsOngoing = exhibition => {
    const exhibitionStatus = eventStatus(exhibition.dateFrom, exhibition.dateTo)
    return exhibitionStatus === eventStatus.status.ONGOING
}

export const customRenderHtmlEditorOutputStyles = (theme) => ({
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
    '& p': {
        fontFamily: "'ATAndreSans' !important",
        color: `${theme.palette.text.main}`,
    },
    '& span': {
        fontFamily: "'ATAndreSans' !important",
        // color: `${theme.palette.text.main} !important`,
    },
    '& p span': {
        fontFamily: "'ATAndreSans' !important",
        // color: `${theme.palette.text.main} !important`,
    },
    '& strong span': {
        // color: `#000000 !important`,
    },
    '& strong p': {
        // color: `#000000`,
    },
    '& strong': {
        // color: `#000000`,
    },
    '& p:nth-of-type(1)': {
        // marginTop: 0
    },
    '& img': {
        maxWidth: "100%",
        height: "auto"
    },
    '& table': {
        display: 'block',                    // required for overflow to work
        overflowX: 'auto !important',
        WebkitOverflowScrolling: 'touch',
        width: '100% !important',
        maxWidth: '100% !important',
        // color: `#000000 !important`,
        border: 'none',
        // marginLeft: '0 !important'
    },
    '& table tr:nth-of-type(odd)': {
        // backgroundColor: '#FFFFFF',
    },
    '& table tr td': {
        // border: 'none !important',
        borderColor: '#f0f0f0 !important',
        // padding: '0.4rem !important', // replace
        paddingLeft: '4px',
        paddingRight: '4px',
        verticalAlign: 'middle !important',
    },
    '& table tr td p': {
        // color: `#000000 !important`,
    },
    '& table tr td p span': {
        // color: `#000000 !important`,
    },
    '& table tr td span': {
        // color: `#000000 !important`,
    },
    '& table tr span p': {
        // color: `#000000 !important`,
    },
    '& table tr:nth-of-type(even)': {
        // backgroundColor: '#f0f0f0',
    },
    '& table tr:first-of-type td': {
        // backgroundColor: `${theme.palette.highlight.main} !important`,
        borderTop: 'none !important',
        // padding: 0 // replace
    },
    '& table tr:first-of-type td:last-of-type': {
        borderTopRightRadius: '0.5rem',
        // borderTop: 'none !important',
        borderRight: 'none !important'
    },
    '& table tr:first-of-type td:first-of-type': {
        borderTopLeftRadius: '0.5rem',
        // borderTop: 'none !important',
        borderLeft: 'none !important'
    }
})

export const checkCatalogDisabled = ({isOrganizer, openExhibitorCatalogue, catalogLocked, daysForCatalogSubmission, dateFrom, dateTo, hideCatalogueProfile, hideCatalogueAddress}) => {
    const status = eventStatus(dateFrom, dateTo)
    const dayBeforeCatalogSubmission = dayjs(dateFrom).subtract(daysForCatalogSubmission, 'd')
    const canFillCatalogIsBefore = dayjs().isSame(dayBeforeCatalogSubmission, 'day')
    const canFillCatalogIsSame = dayjs().isBefore(dayBeforeCatalogSubmission, 'day')
    const canFillCatalog = canFillCatalogIsBefore || canFillCatalogIsSame || openExhibitorCatalogue
    return {
        catalogDisabled: (isOrganizer && catalogLocked) || (!isOrganizer && (catalogLocked || status !== eventStatus.status.UPCOMING || !canFillCatalog)),
        status,
        dayBeforeCatalogSubmission,
        canFillCatalogIsBefore,
        canFillCatalog
    }
}